import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import NoData from "../../../../atoms/NoData";
import { formatCurrency } from "../../../../../functions/formatCurrency";
import moment from "moment";
import { GET_FILE } from "../../../../../api/apiFiles";
import useModal from "../../../../../hooks/useModal";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "../../../../molecules/Modal";
import Button from "../../../../atoms/Button";
import { MdEdit } from "react-icons/md";
import ModalEditEdoCta from "./ModalEditEdoCta";

const TableEstadoDeCuenta = ({ data, loading, refetch }) => {
  const [documento, setDocumento] = useState();
  const [selected, setSelected] = useState();
  const { open, close, isOpen } = useModal();
  const { open: openEdit, close: closeEdit, isOpen: isOpenEdit } = useModal();
  const { id } = useParams();

  const handleOpenDocument = async (s3Key) => {
    try {
      const response = await GET_FILE(id, { s3Key });
      setDocumento(response);
      open();
    } catch (error) {
      console.error(error);
      toast.error("Error al obtener el archivo");
    }
  };

  const handleOpenEdit = (ct) => {
     setSelected(ct);
     openEdit();
  };

  const filesConfig = [
    { key: "pdfFactura", label: "Factura PDF", type: "pdf" },
    { key: "pdfComplemento", label: "Complemento PDF", type: "pdf" },
    { key: "xmlFactura", label: "Factura XML", type: "xml" },
    { key: "xmlComplemento", label: "Complemento XML", type: "xml" },
  ];

  const handleDownloadDocument = async (s3Key) => {
    try {
        const fileUrl = await GET_FILE(id, { s3Key });
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = s3Key;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
        toast.success("Descargando");
    } catch (error) { 
        console.error(error); 
        toast.error("Error al descargar el archivo"); 
    }
};
  const renderFileButtons = (factura) => {
    if (!factura) return null;
    return (
      <div className="flex gap-1 flex-wrap">
        {filesConfig.map(({ key, label, type }) =>
          factura[key] ? (
            <button
              key={key}
              className={`w-fit font-bold p-1.5 rounded-md ${
                type === "pdf"
                  ? "bg-sky-600 hover:bg-rs-azul text-white"
                  : "bg-purple-600 hover:bg-purple-700 text-white"
              }`}
              onClick={() =>
                type === "pdf"
                  ? handleOpenDocument(factura[key].s3Key)
                  : handleDownloadDocument(factura[key].s3Key)
              }
            >
              {label}
            </button>
          ) : null
        )}
      </div>
    );
  };

  const columns = [
    { name: "No. Factura", selector: (row) => row.num_factura, width:"111px"  },
    {
      name: "Concepto de pago",
      cell: (row) => (
        <div>
          <p>{row.payment_concept}</p>
          <p className="text-gray-400 text-sm">{row.comment}</p>
        </div>
      ),
    },
    { name: "Fecha", selector: (row) => moment(row.month).format("DD/MM/YY"), width:"99px" },
    { name: "Pago", selector: (row) => formatCurrency(row.total) },
    {
      name: "Archivos",
      cell: (row) => renderFileButtons(row.factura),
      grow: 3,
    },
    {
        name: "Acciones", 
        cell: (row) => (
            <Button text={<MdEdit size={22} />} onClick={()=>handleOpenEdit(row)} width="w-10" bgColor="blue" />
        ),
        width:"99px"
    }
  ];

  const columnsResponsive = [
    {
      name: "Pagos",
      cell: (row) => (
        <div className="flex flex-col py-1 gap-1">
          <p>Factura: {row.num_factura}</p>
          <p>Fecha: {moment(row.month).format("DD/MM/YY")}</p>
          <p>Monto: {formatCurrency(row.total)}</p>
          <div className="mt-2">{renderFileButtons(row.factura)}</div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="block md:hidden">
        <DataTable
          data={data}
          columns={columnsResponsive}
          progressPending={loading}
          progressComponent={
            <div className="w-full h-20 flex justify-center items-center">
              <PropagateLoader color="red" />
            </div>
          }
          noDataComponent={<NoData />}
          pagination
        />
      </div>
      <div className="hidden md:block">
        <DataTable
          data={data}
          columns={columns}
          progressPending={loading}
          progressComponent={
            <div className="w-full h-20 flex justify-center items-center">
              <PropagateLoader color="red" />
            </div>
          }
          noDataComponent={<NoData />}
          pagination
        />
      </div>

      {isOpen && (
        <Modal title="Previsualización del Documento" onClose={close}>
          <div className="w-full h-[80vh] flex justify-center items-center">
            <iframe
              src={documento}
              className="h-full w-full"
              title="Documento Previsualizado"
            />
          </div>
        </Modal>
      )}
      {isOpenEdit && selected &&
        <Modal title="Editar estado de cuenta" onClose={closeEdit} heigth="h-[65vh]" >
            <ModalEditEdoCta cuenta={selected} onClose={closeEdit} refetch={refetch} id={id} />
        </Modal>
      }
    </div>
  );
};

export default TableEstadoDeCuenta;
